import * as React from 'react';
import { Table } from 'semantic-ui-react';
import { BPBoxWithHeader } from './BPBoxWithHeader';
import { Header, Input, List, Segment } from '@/components/bp/bp-ui';

interface IItemsListProps<T> {
    header?: string | React.ReactNode;
    items: Array<T>;
    renderRow: (item: T, index: number) => React.ReactNode;
    scrolling?: boolean;
    filter?: (item: T, filterText: string) => boolean;
    footer?: string | React.ReactNode;
}

const scrollingStyle: React.CSSProperties = { maxHeight: '50vh', overflowY: 'auto' }

function ItemsList<T>({ header, items, renderRow, scrolling, filter, footer }: IItemsListProps<T>) {
    const [filteredItems, setFilteredItems] = React.useState<Array<T>>(items);
    const [filterValue, setFilterValue] = React.useState<string>('');

    return <>
        {header ? <Header attached="top">{header}
            {filter ? <div style={{ float: "right" }}>
                <Input transparent size={'mini'} placeholder={window.translation.dataTable.search} icon={'search'} value={filterValue}
                    onChange={(ev, data) => {
                        setFilterValue(data.value)
                        filter && setFilteredItems(items.filter((item) => filter(item, data.value)));
                    }} ></Input>

            </div> : null}
        </Header> : null}
        <Segment attached>
            <div style={scrolling ? scrollingStyle : {}}>
                <List divided relaxed>
                    {filteredItems.map((item, index) => renderRow(item, index))}
                </List>
            </div>
            {footer ? footer : null}
        </Segment>
    </>;
}

export default ItemsList;
